import React from 'react';
import cn from 'classnames';
import styles from './post-sidebar.module.css';

export interface IPostSidebar {
  list: any[];
  active: number;
}

export default function PostSidebar({ list, active }: IPostSidebar) {
  return (
    <aside className={styles.sidebar}>
      <h3 className={styles.title}>Contents</h3>
      <ul className={styles.sidebar__list}>
        {list.map((item, index) => (
          <li key={item.id} className={styles.item}>
            <span
              className={cn(styles.count, {
                [styles.active]: active === index + 1,
              })}
            />
            <a href={`#section${item.id}`}>
              <h2
                className={cn(styles.link, {
                  [styles.active]: active === index + 1,
                })}
              >
                {item.subtitle}
              </h2>
            </a>
          </li>
        ))}
      </ul>
    </aside>
  );
}
